const { PUBLIC_URL = '' } = process.env
export const data1 = [
  {
    key: 'Sr. No.',
    id: '0',
    value: `Documents in the Name of Owner / Authorised Signatory
      (Front with Name & Photo + Back with Address)`,
  },
  {
    key: 1,
    id: '1',
    value: 'Aadhaar card copy',
  },
  {
    key: 2,
    id: '2',
    value: 'Passport Copy',
  },
  {
    key: 3,
    id: '3',
    value: "Driver's Licence (Excluding DL issued in Maharashtra)",
  },
  {
    key: 4,
    id: '4',
    value: "Voter's ID",
  },
]

export const data2 = [
  {
    key: 'Sr. No.',
    id: '0',
    value: 'Documents issued in the name of Entity / Firm / Company',
  },
  {
    key: 1,
    id: '1',
    value: 'FSSAI Licence or FDA Certificate',
  },
  {
    key: 2,
    id: '2',
    value: 'Shop & Establishment Certificate',
  },
  {
    key: 3,
    id: '3',
    value: 'GST certificate',
  },
  {
    key: 4,
    id: '4',
    value: 'License issued by Drug Controller Authority',
  },
  {
    key: 5,
    id: '5',
    value:
      'Certificate issued by Gram Panchayat / Block Development Authorities. \n (The certificate must be duly stamped, stating the details of existence of the firm)',
  },
  {
    key: 6,
    id: '6',
    value: 'Certificate issued for Registration / Trade License by Local /State/Central Govt.',
  },
  {
    key: 7,
    id: '7',
    value:
      'Certificate issued for Registration / Trade License by Govt. Agency / SEBI / IRDA / ICAI / ICSI / ICWAI in the name of the entity / firm',
  },
  {
    key: 8,
    id: '8',
    value: 'Registration Certificate issued by Excise / Customs department',
  },
  {
    key: 9,
    id: '9',
    value:
      'VAT Certificate (only applicable for businesses with product types not covered under GST i.e. Petroleum products & Alcohol sellers) (Not applicable for Kirana / Departmental Stores / Supermarket / General Store etc.)',
  },
  {
    key: 10,
    id: '10',
    value: 'Registration Certificate issued by Professional Tax authorities',
  },
  {
    key: 11,
    id: '11',
    value: 'Importer Exporter Certificate (IEC)',
  },
  {
    key: 12,
    id: '12',
    value: 'Trade Mark Registration Certificate',
  },
  {
    key: 13,
    id: '13',
    value: 'Factory Registration Certificate in the name of the Entity',
  },
  {
    key: 14,
    id: '14',
    value:
      'Permanent Small-Scale Industries (SSI) Certificate (not Provisional) Duly stamped and signed by issuing authority.',
  },
]

export const data3 = [
  {
    key: 'Sr. No.',
    id: '0',
    value: 'Documents issued by the bank',
  },
  {
    key: 1,
    id: '1',
    value: 'Cancelled Cheque',
  },
  {
    key: 2,
    id: '2',
    value: 'Bank Verification Letter (not older than 3 months old as on date of onboarding for physical merchants)',
  },
  {
    key: 3,
    id: '3',
    value:
      'Passbook or Bank Statement (transaction entries not more than 3 months old as on date of onboarding; details should be pre-printed in bank statement)',
  },
  {
    key: 4,
    id: '4',
    value: "Voter's ID",
  },
]

export const data4 = [
  {
    docType: 'Document Type',
    key: 'Sr. No.',
    id: '0',
    value: 'Documents issued in the name of Entity / Firm / Company',
  },
  {
    docType: 'Constitution Document (As per constitution)',
    data: [
      {
        id: '1',
        key: '1',
        styledText: 'For Partnership firm - ',
        value: 'Registered Partnership Deed',
      },
      {
        id: '2',
        key: '2',
        styledText: 'For Private / Public Limited Company:\n',
        value:
          'a) Memorandum of Association OR Articles of Association; and\nb) Board of Resolution (To be signed by min 2 directors or Company Secretary)\nc) Certificate of Incorporation',
      },
      {
        id: '3',
        key: '3',
        styledText: 'For Trust -',
        value: ' Trust Deed',
      },
      {
        id: '4',
        key: '4',
        styledText: 'For LLP - ',
        value: 'Certificate of Incorporation & Partnership Deed',
      },
      {
        id: '5',
        key: '5',
        styledText: 'For HUF - ',
        value: 'HUF deed',
      },
      {
        id: '6',
        key: '6',
        value: 'Company PAN',
      },
    ],
    id: '1',
  },
]

export const data5 = [
  {
    docType: 'Document Type',
    key: 'Sr. No.',
    id: '0',
    value: 'Additional Optional Documents of Business',
  },
  {
    docType: 'Authorisation Letter',
    data: [
      {
        id: '1',
        key: '1',
        value:
          'Only required in case entity/firm authorise one or more persons as authorised signatory. Letter of authorisation is required granted by the authorised partners/managing bodies',
      },
    ],
    id: '1',
  },
  {
    docType: 'Financial Document – ANY ONE (Optional)',
    data: [
      {
        id: '1',
        key: '1',
        value: 'Audited Balance Sheet of Last Financial Year',
      },
      {
        id: '2',
        key: '2',
        value: 'Last 3 (Three) months company Bank Account Statement',
      },
      {
        id: '3',
        key: '3',
        value: 'Last 1 (One) Years GST Return / VAT / Income Tax Return',
      },
    ],
    id: '2',
  },
]

export const KYC_DATA = {
  blocks: [
    { key: 'eunuc', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'cb67h',
      text: 'Through JPSL’s fast and frictionless signup process, merchants can start accepting payments with ease; however, they need to ensure that their basic details and requirements are available and updated. As a merchant, you can expect continued support and guidance from our sales teams when establishing a relationship and throughout the payment lifecycle thereafter.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6ssv0',
      text: 'Jio Payment Solutions Limited (formerly known as Reliance Payment Solutions Limited) (JPSL) is committed to comply with the requirements of ‘The Prevention of Money Laundering Act, 2002, rules framed thereunder, and regulatory prescriptions of the Reserve Bank of India (RBI) under ‘Anti-Money Laundering (AML)’, ‘Combatting the Financing of Terrorism (CFT)’ and ‘Know Your Customer (KYC)’ guidelines while on-boarding of merchants. JPSL affirms that it will adopt and implement a robust framework that reflect its ‘zero tolerance’ for all associated risks. JPSL has accordingly adopted this policy known as ‘Merchant Onboarding and KYC-AML Policy’ keeping in view its business requirements.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'f5cm8', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '4adnr',
      text: 'Merchant Onboarding Process',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 27, style: 'BOLD' },
        { offset: 0, length: 27, style: 'FONT_24' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bft2u',
      text: 'Your Onboarding journey begins when you express an interest in JPSL solutions and services and continues beyond account activation for tracking periodic updates and continuous due diligence.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'f5cm9', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'bnfsi',
      text: 'Merchant Registration',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 21, style: 'BOLD' },
        { offset: 0, length: 21, style: 'FONT_24' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: '49d36',
      text: 'Options below to start your registration',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8oti0',
      text: 'Download and Signing up with JPSL Merchant Acquisition Form',
      type: 'unordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 29, length: 30, key: 0 }],
      data: {},
    },
    {
      key: '1h4dj',
      text: 'In case of existing merchant, who needs to expand Jiopay Integration to its other business units, Please refer JPSL Merchant Acquisition Form (Supplementary)',
      type: 'unordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 111, length: 46, key: 1 }],
      data: {},
    },
    {
      key: 'cfhd0',
      text: 'Write us to merchant.support@jiopay.in for more details',
      type: 'unordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 12, length: 27, key: 2 }],
      data: {},
    },
    { key: '97em2', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'don62',
      text: 'Restricted Businesses ',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 22, style: 'BOLD' },
        { offset: 0, length: 22, style: 'FONT_24' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cfi0b',
      text: 'The Merchant will be informed by our Sales/Business team of the list of restricted businesses for which payment processing services will not be offered by JPSL and/or may be evaluated further, subject to additional due diligence and submission of relevant documents by the merchant. The customer should check whether their business falls under the restricted list and proceed accordingly.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'fqdn9',
      text: 'Click here to view detailed information on the restricted businesses.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 0, length: 10, key: 3 }],
      data: {},
    },
    { key: '6kcpe', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '2md1',
      text: 'Document Submission',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 19, style: 'BOLD' },
        { offset: 0, length: 19, style: 'FONT_24' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: '4d68m',
      text: 'Once the merchants has verified their business does not fall under the prohibited list, the merchant further needs to go through the online signup process, they need to upload their KYC documents to complete their registration.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '7m88m',
      text: 'Click here to view List of Documents for Sole Proprietorship and Entity',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 0, length: 10, key: 4 }],
      data: {},
    },
    { key: '74p1a', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'c6nat',
      text: 'Annexure',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 8, style: 'BOLD' },
        { offset: 0, length: 8, style: 'FONT_24' },
      ],
      entityRanges: [],
      data: {},
    },
    { key: '9m41s', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '65oic',
      text: 'ANNEXURE I:  Form (ANX-A) FORMAT OF DECLARATION TO BE FURNISHED WHEN OWNER NAME OR BUSINESS NAME NOT MENTIONED ON PROOF OF BUSINESS ',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 11, style: 'ITALIC' },
        { offset: 26, length: 106, style: 'ITALIC' },
        { offset: 0, length: 11, style: '#003099' },
        { offset: 0, length: 11, style: 'FONT_14' },
        { offset: 0, length: 10, style: 'UNDERLINE' },
        { offset: 12, length: 7, style: 'UNDERLINE' },
        { offset: 24, length: 1, style: 'UNDERLINE' },
        { offset: 0, length: 12, style: 'FONT_16' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: '6nhj7',
      text: 'Click here to view and download the Form (ANX-A)',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 36, length: 6, style: 'UNDERLINE' },
        { offset: 47, length: 1, style: 'UNDERLINE' },
      ],
      entityRanges: [{ offset: 0, length: 11, key: 5 }],
      data: {},
    },
    { key: '8an7v', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '3524v',
      text: 'ANNEXURE II: Form (ANX-B)  FORMAT OF DECLARATION TO BE FURNISHED IN CASE OF MISMATCH OF DATE OF BIRTH ',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 12, style: 'ITALIC' },
        { offset: 27, length: 74, style: 'ITALIC' },
        { offset: 0, length: 12, style: 'UNDERLINE' },
        { offset: 13, length: 6, style: 'UNDERLINE' },
        { offset: 24, length: 1, style: 'UNDERLINE' },
        { offset: 0, length: 12, style: '#003099' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: '3dpcp',
      text: 'Click here to view and download the Form (ANX-B)',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 36, length: 6, style: 'UNDERLINE' },
        { offset: 47, length: 1, style: 'UNDERLINE' },
      ],
      entityRanges: [{ offset: 0, length: 10, key: 6 }],
      data: {},
    },
    { key: 'aqbq5', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '1dsrt',
      text: 'ANNEXURE III: Form (ANX-C) FORMAT OF DECLARATION TO BE FURNISHED IN CASE GST UNAVAILABLE ',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 13, style: 'ITALIC' },
        { offset: 27, length: 61, style: 'ITALIC' },
        { offset: 0, length: 13, style: 'UNDERLINE' },
        { offset: 14, length: 6, style: 'UNDERLINE' },
        { offset: 25, length: 1, style: 'UNDERLINE' },
        { offset: 0, length: 13, style: '#003099' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: '7ummf',
      text: 'Click here to view and download the Form (ANX-C)',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 36, length: 6, style: 'UNDERLINE' },
        { offset: 47, length: 1, style: 'UNDERLINE' },
      ],
      entityRanges: [{ offset: 0, length: 10, key: 7 }],
      data: {},
    },
    { key: 'ee7of', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
  ],
  entityMap: {
    '0': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: `${PUBLIC_URL}/docs/Onboarding/JPSL-MAF_Apr-24_v1.17B.pdf` },
    },
    '1': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: `${PUBLIC_URL}/docs/Onboarding/JPSL-MAF(Suppl.)_Apr-24_v5.pdf` },
    },
    '2': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:merchant.support@jiopay.in' } },
    '3': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: `${PUBLIC_URL}/docs/Onboarding/restricted_business_list.pdf` },
    },
    '4': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: `${PUBLIC_URL}/docs/Onboarding/list_of_documents_for_sole_proprietorship_and-entity.pdf` },
    },
    '5': { type: 'LINK', mutability: 'MUTABLE', data: { url: `${PUBLIC_URL}/docs/Onboarding/annexure_form_A.pdf` } },
    '6': { type: 'LINK', mutability: 'MUTABLE', data: { url: `${PUBLIC_URL}/docs/Onboarding/annexure_form_B.pdf` } },
    '7': { type: 'LINK', mutability: 'MUTABLE', data: { url: `${PUBLIC_URL}/docs/Onboarding/annexure_form_C.pdf` } },
  },
}
